import React, { useCallback, useEffect, useState } from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  EligibleCertificateAccount,
  UserSearchReq,
  CreateCertificate as CreateCertificateAPI,
  getCertificatesDetails,
  getLifetimeCertificatesDetails,
  baseUrl,
} from "../../utils/api/apis";
import { CircularProgress } from "@mui/material";
import Select from "react-select";
import { returnErrors } from "../../store/reducers/error";
import { returnMessages } from "../../store/reducers/message";
import random from "../../assets/images/background.jpg";
import Pagination from "@mui/material/Pagination";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../utils/string";

function CertificateManagement() {
  const navigate = useNavigate(); // Hook for navigation
  const location = useLocation(); // Hook to get current route.

  // Define route options for the dropdown
  const routeOptions = [
    { value: "/CertificateManagement", label: "All Certificates" },
    {
      value: "/CertificateManagement/create-certificate",
      label: "Create Certificate",
    },
  ];

  // Get the current route path to set the active state
  const currentRoute =
    routeOptions.find((option) => option.value === location.pathname) ||
    routeOptions[0];

  // Handle route change
  const handleRouteChange = (selectedOption) => {
    navigate(selectedOption.value);
  };

  return (
    <div className="funding_evaluation">
      <div className="grid_container">
        <div className="mobileNavSelector">
          {/* Add React Select for route navigation */}
          <Select
            options={routeOptions}
            value={currentRoute}
            onChange={handleRouteChange}
            isSearchable={false}
          />
        </div>
        <div className="divs">
          <Routes>
            <Route
              path="/CertificateManagement"
              element={<Navigate to="/" replace={true} />}
            />

            <Route path="/" element={<ViewCertificate />} />
            <Route path="create-certificate" element={<CreateCertificate />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default CertificateManagement;

function CreateCertificate() {
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [emailOpts, setEmailOpts] = useState([{ label: "", value: "" }]);
  const [validUsers, setValidUsers] = useState([{ label: "", value: "" }]);
  const [certificateType, setCertificateType] = useState([]);
  const [tradingPlatform, setTradingPlatform] = useState(null);

  const [data, setData] = useState({});

  const [validAccounts, setValidAccounts] = useState({});

  const customStyles = {
    control: (provided) => ({
      ...provided,
      background: "none",
      width: "100%",
      marginTop: "0px",
      borderRadius: 8,
      border: "1px solid #eaf0f8;",
      boxShadow: "none",
      fontFamily: "DM Sans, sans-serif",
      fontSize: "14px",
      fontWeight: 700,
      minHeight: "48px",
      height: "48px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "grey",
      fontSize: "14px",
      fontWeight: 500,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "48px",
      padding: "0 6px",
      fontWeight: 500,
      marginLeft: "10px",
      color: "#000",
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      color: "#000",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "48px",
    }),
  };

  // User search by email
  const fetch = async (value) => {
    setIsLoading(true);
    const response = await UserSearchReq(idToken, value);
    setIsLoading(false);
    if (response?.status < 399) {
      let userArray = [];
      response.data.map((item) =>
        userArray.push({
          label: item?.email,
          value: item?.id,
        }),
      );

      setEmailOpts(userArray);
    } else {
      if (response?.response?.data?.message) {
        return;
      }
      let msg = response?.response?.data?.detail || "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
  };

  useEffect(() => {
    setData((prev) => ({ ...prev, login_id: "" }));

    const validLoginID = [];

    if (data.type && certificateType) {
      certificateType.forEach((item) => {
        if (item.label === data.type && Array.isArray(item.value)) {
          item.value.forEach((value) => {
            validLoginID.push({ value: value, label: value });
          });
        }
      });
      setValidUsers(validLoginID);
    }
    console.log(validLoginID, "validLoginID");
  }, [data.type, certificateType]);

  useEffect(() => {
    const data = Object.keys(validAccounts)
      .filter((key) => validAccounts[key])
      .map((key) => ({
        value: validAccounts?.[key],
        label: (key =
          key === "step_1"
            ? "1 Step"
            : key === "step_2"
              ? "2 Step"
              : key === "payout"
                ? "Payout"
                : key === "lifetime_payout"
                  ? "Lifetime Payout"
                  : "Funded"),
      }));
    setCertificateType(data);
  }, [validAccounts]);

  //get valid accounts
  const getValidAccounts = async (email) => {
    setIsLoading(true);
    const response = await EligibleCertificateAccount(idToken, email);
    setIsLoading(false);
    if (response?.status < 399) {
      setValidAccounts(response.data);
    } else {
      if (response.response.data.message) {
        return;
      }
      let msg = response?.response?.data?.detail || "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
  };

  const CreateCertificate = async () => {
    if (
      !data.type ||
      !data.user ||
      (data.type !== "Lifetime Payout" && !data.login_id)
    ) {
      dispatch(returnErrors("All fields are required", 400));
      return;
    }
    if (data.type === "Payout" && !data.amount) {
      dispatch(returnErrors("Amount is required", 400));
      return;
    }
    setIsSpinner(true);
    const newData = {
      type:
        data?.type === "1 Step"
          ? "1_step"
          : data?.type === "2 Step"
            ? "2_step"
            : data?.type === "Payout"
              ? "profit_split"
              : data?.type === "Lifetime Payout"
                ? "lifetime_payout"
                : "funded",
      user: data?.user,
      login_id: data?.login_id,
      amount: data?.amount,
      trading_platform: tradingPlatform,
    };
    const response = await CreateCertificateAPI(idToken, newData);
    if (response?.status < 399) {
      dispatch(returnMessages("Certificate Created", 200));
      setIsSpinner(false);
    } else {
      setIsSpinner(false);
      if (response.response.data.message) {
        return;
      }
      let msg = response?.response?.data?.detail || "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
  };
  let timeoutId;

  const handleOninputChange = (value) => {
    if (typeof value === "string" && value.length > 0) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fetch(value);
      }, 1500);
    }
  };

  console.log("validUsers", data);

  const getTradingPlatform = useCallback(async () => {
    try {
      const res = await axios.get(`${baseUrl}certificate/platform/`, {
        headers: {
          Authorization: `Bearer ${idToken}`,
          Accept: "application/json",
        },
        params: {
          email: data?.user,
          login_id: data?.login_id,
        },
      });
      console.log("res?.tradingPlatform", res?.data?.platforms);
      setTradingPlatform(res?.data?.platforms[0]);
    } catch (error) {
      let msg = error || "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
  }, [idToken, data?.user, data?.login_id, dispatch]);

  useEffect(() => {
    if (data?.user && data?.login_id) {
      getTradingPlatform();
    }
  }, [data?.user, data?.login_id, getTradingPlatform]);

  return (
    <>
      <div className="create_trading_account">
        <div className="create_header">
          <p>Create Certificate</p>
        </div>
        <div className="create_trading_account_wrapper">
          <div className="input_form">
            {/* <div className="input_form-top">
              <div className="input_wrapper">
                <label htmlFor="accountName">Account name</label>
                <input
                  type="text"
                  name="accountName"
                  placeholder="account name"
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="password"> Password </label>
                <input type="text" name="password" placeholder="********" />
              </div>
            </div> */}
            <div className="input_form-mid">
              <div className="input_wrapper">
                <label htmlFor="Email">Email</label>
                <Select
                  isLoading={isLoading}
                  placeholder={"Search for a user"}
                  styles={customStyles}
                  options={emailOpts}
                  onInputChange={(value) => handleOninputChange(value)}
                  onChange={(selectedOption) => {
                    setData((prev) => ({
                      ...prev,
                      user: selectedOption.label,
                    }));
                    getValidAccounts(selectedOption.label);
                  }}
                />
              </div>
            </div>

            <div className="input_form-btm">
              <div className="input_wrapper">
                <label htmlFor="">Type</label>
                <Select
                  isLoading={isLoading}
                  placeholder={"Select Certificate Type"}
                  styles={customStyles}
                  options={certificateType}
                  onChange={(selectedOption) => {
                    setData((prev) => ({
                      ...prev,
                      type: selectedOption.label,
                    }));
                  }}
                />
              </div>
              {data?.type !== "Lifetime Payout" && (
                <div className="input_wrapper">
                  <label htmlFor="Email">Login ID</label>
                  <Select
                    isLoading={isLoading}
                    placeholder={"Select Certificate Type"}
                    styles={customStyles}
                    options={validUsers}
                    // value={data.login_id}
                    // onInputChange={(value) => {
                    //   const valid = typeof value;
                    //   valid === "string" && fetch(value);
                    // }}
                    value={{ label: data.login_id, value: data.login_id }}
                    onChange={(selectedOption) => {
                      setData((prev) => ({
                        ...prev,
                        login_id: selectedOption.value,
                      }));
                    }}
                  />
                </div>
              )}
            </div>
            {data.type && data.type !== "Lifetime Payout" && (
              <div className="input_form-mid">
                <div className="input_wrapper">
                  <label htmlFor="Email">Amount</label>
                  <input
                    type="number"
                    onChange={(e) => {
                      setData((prev) => ({ ...prev, amount: e.target.value }));
                    }}
                  />
                </div>
              </div>
            )}

            <div
              onClick={() => CreateCertificate()}
              className="view_details_btn"
            >
              {isSpinner ? <CircularProgress color="inherit" /> : "Create"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const ViewCertificate = () => {
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  //For Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [certificateType, setCertificateType] = useState("payout");
  const [payoutFilter, setPayoutFilter] = useState("payout");
  const [isLoadingCertificates, setIsLoadingCertificates] = useState(false);

  console.log("currentPage", currentPage);

  const [certificateList, setCertificateList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isLoadingUser, setIsLoadingUser] = useState(false);
  const [userEmailOpts, setUserEmailOpts] = useState([]);

  const handleChange = (event, value) => {
    setCurrentPage(value);
    setRefresh(!refresh);
  };
  const [search, setSearch] = useState(null);
  const { selectedBrand } = useSelector((state) => state.brand);

  const getData = useCallback(async () => {
    setIsLoadingCertificates(true);
    setCertificateList([]);
    const startTime = Date.now();
    try {
      if (certificateType === "payout") {
        const response = await getCertificatesDetails(
          idToken,
          currentPage,
          search,
          null,
          selectedBrand,
          payoutFilter,
        );

        setTotalPages(Math.ceil(response?.data?.count / 20)); //20 refers to the page size of api call

        if (response?.status === 200) {
          let results = response.data?.results || [];

          setCertificateList(results);
        }
      } else if (certificateType === "lifetime_payout") {
        const response = await getLifetimeCertificatesDetails(
          idToken,
          selectedUserId,
          search,
          null,
          selectedBrand,
        );

        if (response?.status === 200) {
          if (Array.isArray(response.data?.results)) {
            const transformedResults = response.data.results.map((item) => ({
              ...item,
              file: item.file || item.file_url,
              login_id: item.login_id || item.user_id,
            }));
            setCertificateList(transformedResults);
            setTotalPages(Math.ceil(response.data.count / 20));
          } else if (response.data?.file_url) {
            // Transform the single certificate response into an array format
            const lifetimeCert = {
              ...response.data,
              title: response.data.title,
              file: response.data.file_url,
              login_id: selectedUserId || response.data.login_id,
              created_at: response.data.created_at,
              total_amount: response.data.total_amount,
              payout_count: response.data.payout_count,
            };
            setCertificateList([lifetimeCert]);
            setTotalPages(1);
          } else {
            setCertificateList([]);
            setTotalPages(1);
          }
        } else {
          setCertificateList([]);
          setTotalPages(1);
        }
      }
    } finally {
      // Ensure loading spinner is visible for at least 400ms to avoid jarring flickers
      const elapsed = Date.now() - startTime;
      const minLoadingTime = 400;
      if (elapsed < minLoadingTime) {
        await new Promise((resolve) =>
          setTimeout(resolve, minLoadingTime - elapsed),
        );
      }
      setIsLoadingCertificates(false);
    }
  }, [
    idToken,
    currentPage,
    certificateType,
    search,
    selectedBrand,
    payoutFilter,
    selectedUserId,
  ]);

  useEffect(() => {
    getData();
  }, [getData]);

  // User search for lifetime certificates
  let userSearchTimeout;
  const handleUserSearch = async (value) => {
    if (typeof value === "string" && value.length > 0) {
      clearTimeout(userSearchTimeout);
      userSearchTimeout = setTimeout(async () => {
        setIsLoadingUser(true);
        const response = await UserSearchReq(idToken, value);
        setIsLoadingUser(false);
        if (response?.status < 399) {
          let userArray = [];
          response.data.map((item) =>
            userArray.push({
              label: item?.email,
              value: item?.id,
            }),
          );
          setUserEmailOpts(userArray);
        } else {
          if (response?.response?.data?.message) {
            return;
          }
          let msg = response?.response?.data?.detail || "Something went wrong";
          dispatch(returnErrors(msg, 400));
        }
      }, 1500);
    }
  };

  const [gotoPageInput, setGotoPageInput] = useState();

  const handleGotoPage = () => {
    const pageNumber = parseInt(gotoPageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setRefresh(!refresh);
      setGotoPageInput("");
    }
  };

  return (
    <>
      <div className="viewCertificateCon">
        <div className="viewCertificate-Head">Certificates</div>

        <div className="viewCertificate-wrapper">
          {/* Mobile dropdown - shown below 900px */}
          <div className="mobile_dropDowns">
            <Select
              placeholder="Select Certificate Type"
              classNamePrefix="react-select"
              options={[
                { label: "All", value: "all" },
                { label: "Payout Certificates", value: "payout" },
                {
                  label: "Lifetime Payout Certificates",
                  value: "lifetime_payout",
                },
                { label: "Challenge Certificates", value: "challenge" },
                { label: "Funded Certificates", value: "funded" },
              ]}
              value={
                certificateType === "lifetime_payout"
                  ? {
                      label: "Lifetime Payout Certificates",
                      value: "lifetime_payout",
                    }
                  : certificateType === "payout"
                    ? {
                        label:
                          payoutFilter === "all"
                            ? "All"
                            : payoutFilter === "payout"
                              ? "Payout Certificates"
                              : payoutFilter === "challenge"
                                ? "Challenge Certificates"
                                : "Funded Certificates",
                        value: payoutFilter,
                      }
                    : null
              }
              onChange={(selectedOption) => {
                setIsLoadingCertificates(true);
                setCertificateList([]);
                setCurrentPage(1);
                if (selectedOption.value === "lifetime_payout") {
                  setCertificateType("lifetime_payout");
                } else {
                  setCertificateType("payout");
                  setPayoutFilter(selectedOption.value);
                }
                setRefresh(!refresh);
              }}
            />
          </div>

          {/* Desktop pills - shown above 900px */}
          <div
            className="desktop_pills certificate-pills"
            style={{ display: "flex", gap: "10px", flexWrap: "nowrap" }}
          >
            <button
              className={
                certificateType === "payout" && payoutFilter === "all"
                  ? "activeBtn"
                  : ""
              }
              onClick={() => {
                setIsLoadingCertificates(true);
                setCertificateList([]);
                setCertificateType("payout");
                setPayoutFilter("all");
                setCurrentPage(1);
                setRefresh(!refresh);
              }}
            >
              All
            </button>
            <button
              className={
                certificateType === "payout" && payoutFilter === "payout"
                  ? "activeBtn"
                  : ""
              }
              onClick={() => {
                setIsLoadingCertificates(true);
                setCertificateList([]);
                setCertificateType("payout");
                setPayoutFilter("payout");
                setCurrentPage(1);
                setRefresh(!refresh);
              }}
            >
              Payout Certificates
            </button>
            <button
              className={
                certificateType === "lifetime_payout" ? "activeBtn" : ""
              }
              onClick={() => {
                setIsLoadingCertificates(true);
                setCertificateList([]);
                setCertificateType("lifetime_payout");
                setCurrentPage(1);
                setRefresh(!refresh);
              }}
            >
              Lifetime Payout Certificates
            </button>
            <button
              className={
                certificateType === "payout" && payoutFilter === "challenge"
                  ? "activeBtn"
                  : ""
              }
              onClick={() => {
                setIsLoadingCertificates(true);
                setCertificateList([]);
                setCertificateType("payout");
                setPayoutFilter("challenge");
                setCurrentPage(1);
                setRefresh(!refresh);
              }}
            >
              Challenge Certificates
            </button>
            <button
              className={
                certificateType === "payout" && payoutFilter === "funded"
                  ? "activeBtn"
                  : ""
              }
              onClick={() => {
                setIsLoadingCertificates(true);
                setCertificateList([]);
                setCertificateType("payout");
                setPayoutFilter("funded");
                setCurrentPage(1);
                setRefresh(!refresh);
              }}
            >
              Funded Certificates
            </button>
          </div>

          {/* Search area - always rendered, toggled via display to prevent layout shift */}
          <div style={{ width: "200px", flexShrink: 0 }}>
            <div
              className="user-search-dropdown"
              style={{
                display: "flex",
              }}
            >
              <Select
                isLoading={isLoadingUser}
                placeholder="Search for a user..."
                classNamePrefix="react-select"
                options={userEmailOpts}
                onInputChange={(value, { action }) => {
                  if (action === "input-change") {
                    handleUserSearch(value);
                  }
                }}
                onChange={(selectedOption) => {
                  setSelectedUserId(selectedOption ? selectedOption.value : null);
                  setSearch(selectedOption ? selectedOption.label : null);
                  setCurrentPage(1);
                  setRefresh(!refresh);
                }}
                isClearable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minWidth: "150px",
                    maxWidth: "200px",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #b0b0b0",
                    },
                  }),
                  menu: (provided) => ({
                    ...provided,
                    minWidth: "150px",
                    maxWidth: "200px",
                  }),
                }}
              />
            </div>
          </div>
        </div>

        {isLoadingCertificates ? (
          <div className="lifetime-certificate-placeholder">
            <CircularProgress style={{ color: "#36d66b" }} />
          </div>
        ) : (
          <>
            <div className="CertificateContainer">
              {certificateList?.map((item, index) => {
                return (
                  <CertificateItem
                    key={index}
                    img={item.file || item.file_url}
                    title={item.title}
                    loginID={item.login_id}
                    createdAt={item.created_at}
                    type={item.type}
                    total_amount={item.total_amount}
                    payout_count={item.payout_count}
                    isLifetime={certificateType === "lifetime_payout"}
                  />
                );
              })}
            </div>
            {certificateList?.length === 0 && (
              <div className="lifetime-certificate-placeholder">
                <p>No certificates available</p>
              </div>
            )}
          </>
        )}
        <div
          className="paginationWrapper"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            padding: "20px 0px",
          }}
        >
          <div className="spacerT30p"></div>
          <Pagination
            onChange={handleChange}
            count={totalPages}
            page={currentPage}
            variant="outlined"
            color="primary"
          />
          <div className="goto-page-input">
            <input
              type="number"
              placeholder="Go to Page"
              value={gotoPageInput}
              onChange={(e) => setGotoPageInput(e.target.value)}
            />
            <button className="goToButton" onClick={handleGotoPage}>
              Go
            </button>
          </div>
        </div>
      </div>
    </>
  );

  function CertificateItem({
    img,
    title,
    loginID,
    createdAt,
    type,
    total_amount,
    payout_count,
    isLifetime,
  }) {
    return (
      <a
        href={img}
        target="_blank"
        rel="noreferrer"
        className="CertificateItem"
      >
        <img src={img ? img : random} alt="" />

        <div className="Twrapper">
          {title && (
            <div className="tcon">
              <p>Title:</p>
              <span>
                {title.includes(" - ") ? title.split(" - ")[1] : title}
              </span>
            </div>
          )}
          <div className="tcon">
            <p>{isLifetime ? "User ID:" : "Login ID:"}</p>
            <span>{loginID}</span>
          </div>

          <div className="tcon">
            <p>Created At:</p>
            <span>{formatDate(createdAt)}</span>
          </div>

          {type && (
            <div className="tcon">
              <p>Type:</p>
              <span>{type}</span>
            </div>
          )}

          {total_amount !== undefined && (
            <div className="tcon">
              <p>Total Amount:</p>
              <span>${parseFloat(total_amount).toFixed(2)}</span>
            </div>
          )}

          {payout_count !== undefined && (
            <div className="tcon">
              <p>Payout Count:</p>
              <span>{payout_count}</span>
            </div>
          )}
        </div>
      </a>
    );
  }
};
